// extracted by mini-css-extract-plugin
export default {"coreloader":"coreloader_coreloader__u7UgJ"};